import { PartRecord } from "models/view-models/part-record";
import ArticleTableOfContentsRecord from "models/view-models/table-of-contents/article-table-of-contents-record";
import VirtualTableOfContentsSection from "molecules/virtual-table-of-contents-items/virtual-table-of-contents-section";
import React, { useEffect } from "react";
import { CollectionUtils } from "utilities/collection-utils";
import { SectionParentType } from "utilities/enumerations/section-parent-type";
import useBookviewTableOfContents from "utilities/hooks/domain/publications/use-bookview-table-of-contents";
interface VirtualTableOfContentsArticleSectionsProps {
    chapterNfpaLabel: string;
    article: ArticleTableOfContentsRecord;
    publicationId: number;
}
const VirtualTableOfContentsArticleSections = (
    props: VirtualTableOfContentsArticleSectionsProps
) => {
    const { chapterNfpaLabel, article, publicationId } = props;

    const { getTableOfContentsArticleSection, articlesLoading } =
        useBookviewTableOfContents();

    useEffect(() => {
        if (!articlesLoading && !CollectionUtils.hasValues(article.sections)) {
            getTableOfContentsArticleSection(
                publicationId,
                article.id,
                article.chapterId
            );
        }
    }, [
        article.chapterId,
        article.id,
        article.sections,
        articlesLoading,
        getTableOfContentsArticleSection,
        publicationId,
    ]);
    return (
        <VirtualTableOfContentsSection
            chapterNfpaLabel={chapterNfpaLabel}
            sections={article.sections ?? []}
            parts={article.parts as PartRecord[]}
            useHashLinks={false}
            parentType={SectionParentType.Article}
        />
    );
};

export default VirtualTableOfContentsArticleSections;
